import { render } from "./BookInfor.vue?vue&type=template&id=22634bf4&scoped=true"
import script from "./BookInfor.vue?vue&type=script&lang=js"
export * from "./BookInfor.vue?vue&type=script&lang=js"

import "./BookInfor.vue?vue&type=style&index=0&id=22634bf4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-22634bf4"

export default script